<template>
  <div v-if="showMarketingBox" class="marketing-box" data-test="marketing-box">
    <div v-if="small" class="grid-x mobile">
      <div class="img cell">
        <img class="mobile-img" :src="model.imgMobile.url" :alt="model.imgMobile.alt" />
      </div>
      <p class="cell auto" v-html="model.text" />
    </div>
    <div v-else class="desktop">
      <h3 v-text="model.titleImg" />
      <img class="desktop-img" :src="model.imgDesktop.url" :alt="model.imgDesktop.alt" />
      <h3 v-text="model.titleText" />
      <p v-html="model.text" />
    </div>
  </div>
</template>

<script lang="ts">
// Define the component in non-class-style syntax (TypeScript)
import { defineComponent } from 'vue';
import { watchSmallScreen, mqObject } from '@/common/Util/visualUtils';
import IMarketingBox from '@/interfaces/IMarketingBox';

export default defineComponent({
  name: 'MarketingBox',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      small: mqObject.isSmallOnly as boolean
    };
  },
  computed: {
    showMarketingBox(): boolean {
      return this.$store.state.marketingBox.showMarketingBox;
    },
    model(): IMarketingBox {
      return this.$store.state.marketingBox.data;
    }
  },
  created(): void {
    if (this.id) {
      this.$store.dispatch('marketingBox/setId', this.id);
      this.$store.dispatch('marketingBox/getData', 1);
    }
  },
  mounted(): void {
    watchSmallScreen((evt: MediaQueryListEvent) => {
      this.small = evt.matches;
    });
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';

.marketing-box {
  .desktop {
    & h3 {
      margin: 0;
      color: $text;
    }

    & :nth-child(n) {
      padding-bottom: rem-calc(9px);
    }

    & :last-child {
      padding-bottom: 0;
    }
  }
  .mobile {
    .img {
      max-width: rem-calc(70px);
      padding-right: rem-calc(20px);
    }
  }
}
</style>
